import { APICore, API_URL } from './apiCore';

const api = new APICore();

const getChats = (params: { page?: number; chatFilter?: string; sort?: string; pensionStatus?: string; search?: string; repId?: string }) => {
    if (!params.page) {
        params.page = 0;
    }

    const relativeUrl = '/chats';
    return api.get(`${API_URL}${relativeUrl}`, params);
};

const getUnreadCount = () => {
    const relativeUrl = '/chats/unread-count';
    return api.get(`${API_URL}${relativeUrl}`);
};

const getManagerTeam = () => {
    const relativeUrl = '/users/manager-team';
    return api.get(`${API_URL}${relativeUrl}`);
};

const getChatMessages = (chatId: string, page: number, search: string) => {
    const relativeUrl = '/chats';
    return api.get(`${API_URL}${relativeUrl}/${chatId}/messages?page=${page}&search=${search || ''}`);
};

const downloadChatMessages = async (chatId: string) => {
    const relativeUrl = '/chats';
    const response = await api.getFile(`${API_URL}${relativeUrl}/${chatId}/messages/download`);

    // Create a blob from the response
    const blob = await response.blob();

    // Create a download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;

    // Extract filename from response headers or use default
    const contentDisposition = response.headers.get('content-disposition');
    let filename = 'chat_messages.csv';
    if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
        if (filenameMatch) {
            filename = filenameMatch[1];
        }
    }

    link.download = filename;

    // Trigger download
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};

const updateChat = (
    chatId: string,
    params: {
        unpoke?: boolean;
        unreadCount?: number;
        isStarred?: boolean;
        isPinned?: boolean;
        addFollowerId?: string;
        removeFollowerId?: string;
        removeFollower?: boolean;
    },
) => {
    const relativeUrl = '/chats';
    return api.update(`${API_URL}${relativeUrl}/${chatId}`, params);
};

const updateChatFollower = (body: { followerId: string; chatIds: string[] }) => {
    const relativeUrl = `/chats/add-follower`;
    return api.create(`${API_URL}${relativeUrl}`, body);
};

const updatePokeUser = (body: { chatId?: string; userId: string; clientId?: string }) => {
    const relativeUrl = `/chats/poke`;
    return api.update(`${API_URL}${relativeUrl}`, body);
};

export { getChats, getUnreadCount, getChatMessages, downloadChatMessages, updateChat, getManagerTeam, updateChatFollower, updatePokeUser };
